import { useQuery } from '@apollo/client';
import { GET_MY_STORE } from '../graphql/queries';

export interface MyStore {
  storeId: string;
  clientId: string;
  storeName: string;
  emailId: string | null;
  mobileNumber: string | null;
  status: boolean;
  portal: 'manufacturer' | 'distributor' | string;
  storeType: 'rietail' | 'custom' | string | null;
  catalogType: 'product' | 'service' | string | null;
  isSubscriptionActive: boolean | null;
  isFreeAccount: boolean | null;
}

/**
 * Fetches the authenticated store via the API gateway.
 * Runs once after the utoken is available (i.e. after verifyStore succeeds).
 */
export const useMyStore = () => {
  const { data, loading, error, refetch } = useQuery(GET_MY_STORE, {
    fetchPolicy: 'cache-and-network',
  });

  const store: MyStore | null = data?.getMyStore ?? null;
  return { store, loading, error, refetch };
};

/**
 * Two-letter initials derived from the store/company name.
 * "Sharma Industries Ltd" → "SI",  "Acme" → "AC".
 */
export const getStoreInitials = (name?: string | null): string => {
  if (!name) return '';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
};
